'use client';

import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import DynamicButton from '@components/DynamicButton';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';

export default function WimbledonBridgeWelcome(
  props: MarketingPageComponentProps
) {
  const content = props.locale.section?.wimbledonBridgeWelcomeContent || [];

  return (
    <Stack
      component="section"
      className={cn.wimbledonBridgeWelcome}
      id="wimbledonBridgeWelcomeID"
    >
      <Box
        className={cn.wimbledonWelcomeInner}
        sx={{
          backgroundImage: `url(${props.images.wimbledon_bridge_green_background?.src})`,
        }}
      >
        <CommonContainer
          maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
          flexGrow={1}
        >
          <Box className={cn.wimbledonWelcomeBody}>
            <Box className={cn.wimbledonWelcomeBlock}>
              <Box className={cn.wimbledonWelcomeHeading}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section?.wimbledonBridgeWelcomeHeading || ''
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.wimbledonWelcomeContent}>
                <Box className={cn.wimbledonWelcomeContent__data}>
                  {content.map((item: string, index: number) => (
                    <ParallaxText
                      key={index}
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(item)}
                    </ParallaxText>
                  ))}
                </Box>
              </Box>
            </Box>
            <Box className={cn.wimbledonWelcomeButton}>
              <DynamicButton
                className={cn.wimbledonButtonItem}
                children={
                  props.locale.section?.wimbledonBridgeWelcomeButton || ''
                }
                scrollToId="wimbledonBridgeRegistrationID"
              />
            </Box>
            <Box className={cn.wimbledonWelcomeStory}>
              <Box className={cn.wimbledonWelcomeStory__element}>
                <CustomImage
                  src={props.images.wimbledon_bridge_welcome_banner?.src || ''}
                  alt={'BrookGreen Introduction Image'}
                  width={768}
                  height={768}
                />
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
